import { authClient, baseClient, getServiceURL } from '@/utils'
import Toggles from '@domain/toggles/Toggles'
import { ApiCaller } from '@front/utils'


const getUser = (userId) => {
	return authClient.get(`${getServiceURL('users')}/v1/users/${userId}`)
}

const getUserByEmail = (email) => {
	return baseClient
		.get(`${getServiceURL('users')}/v1/users/email-validate/${email}`)
		.then((data) => data)
		.catch((error) => error)
}

const userConfigurationsBySiteLocation = (siteLocation) => {
	return authClient.get(`${getServiceURL('masters')}/v1/configurations`, {
		params: {
			siteLocation
		}
	})
}

const fetchBusinessActivitiesType = ({ lang }) => {
	return baseClient.get(`${getServiceURL('users')}/v1/company-types`, {
		params: { lang }
	})
}

const fetchSubmenuLinks = ({ catalogId, role }) => {
	return authClient.get(`${getServiceURL('masters')}/v1/configurations/menus`, {
		params: { catalogId, role }
	})
}

const checkEmailAvailability = (email) => {
	return baseClient
		.get(`${getServiceURL('users')}/v1/users/email-validate/${email}`)
		.then(() => ({
			data: false,
			status: 200
		}))
		.catch((error) => {
			if (error.response.status === 404) {
				return {
					data: true,
					status: 200
				}
			}
			return error
		})
}

const updateClientCode = ({ userId, clientCode, lang }) => {
	return authClient.patch(`${getServiceURL('users')}/v1/users/${userId}/client-code`, {
		clientCode: clientCode,
		lang
	})
}

const updateLanguage = async (userId, selectedLanguage) => {
	const languageId = selectedLanguage.id
	const languageIsoCode = selectedLanguage.isoCode
	let data
	if (Toggles.isEnabled("editLanguagesFromApiHub")) {
		data = await ApiCaller.call('v2', "PUT", `user/${userId}`, JSON.stringify({ language: selectedLanguage }))
	} else {
		data = authClient.patch(`${getServiceURL('users')}/v1/users/${userId}/lang`, {
			language: {
				id: languageId,
				isoCode: languageIsoCode,
			}
		})
	}
	return data
}

const fetchUsersPrivileges = (crmCopmanyID) => {
	return authClient.get(`${getServiceURL('users')}/v1/users/manage/by-company/${crmCopmanyID}`)
}

const updateUsersPrivileges = ({ updatedPrivileges }) => {
	return authClient.patch(`${getServiceURL('users')}/v1/users/manage/by-company/modify-user-privileges`,
		updatedPrivileges
	)
}
const updateUserAboutYou = async (userId, formData) => {
	let response
	if (Toggles.isEnabled("updateAboutYouQualifiedUser")) {
		const data = await ApiCaller.call('v2', "PUT", `user/${userId}`, JSON.stringify(formData), { credentials: "include" })
		response = { data }
	} else {
		response = authClient.put(`${getServiceURL('users')}/v1/users/${userId}`, formData)
	}
	return response
}

const updateUserAboutCompany = async (userId, formData) => {
	let response = null

	if (Toggles.isEnabled("swapUpdateCompanyToApiHubInsteadOfV1")) {
		const companyId = formData.company?.crmId
		const data = await ApiCaller.call('v2', "PUT", `company/${companyId}`, JSON.stringify(formData), { credentials: "include" })
		response = { data }
	} else {
		response = await authClient.patch(`${getServiceURL('users')}/v1/users/${userId}/company`, formData)
	}
	return response
}


const getUserProfessions = () => baseClient.get(`${getServiceURL('apiv2')}/options/professions`)


export default {
	getUser,
	getUserByEmail,
	getUserProfessions,
	fetchBusinessActivitiesType,
	fetchSubmenuLinks,
	checkEmailAvailability,
	fetchUsersPrivileges,
	updateClientCode,
	userConfigurationsBySiteLocation,
	updateLanguage,
	updateUsersPrivileges,
	updateUserAboutYou,
	updateUserAboutCompany
}
